<template>
  <div>
    <strong class="d-block">Transportación:</strong>
    <div v-if="canChangeTransport || hasAllowedOptions">
      <custom-drop-down
        v-model="selectedOption"
        :options="allowedOptions"
        fieldkey="id"
        fieldname="text"
        :disabled="disabled || isPS"
        @input="onOptionChange"
      />
    </div>
    <span v-else>{{ selectedOptionText }}</span>
  </div>
</template>

<script>
import { CustomDropDown } from '@/components/common';
import store from '@/store/index';

import peiProgramAreas from '@/utils/constants/pei/peiProgramAreas';

export default {
  name: 'TransportationOptions',
  props: {
    value: {
      type: String,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    allowedTransportOptions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CustomDropDown,
  },
  data() {
    return {
      selectedOption: null,
      options: [
        { id: '261', text: 'NO ES NECESARIO' },
        { id: '139', text: 'REGULAR' },
        { id: '141', text: 'PORTEADOR' },
        { id: '140', text: 'BECA' },
      ],
    };
  },
  methods: {
    onOptionChange(item) {
      this.$emit('onChange', item);
    },
  },
  mounted() {
    this.selectedOption = this.options.find((a) => a.id == this.value);
  },
  watch: {
    value(newValue) {
      this.selectedOption = this.options.find((a) => a.id == newValue);
    },
  },
  computed: {
    selectedOptionText() {
      if (this.selectedOption) return this.selectedOption.text;
      return '';
    },
    canChangeTransport() {
      return store.getters.canChangeTransportationType;
    },
    hasAllowedOptions() {
      return (
        this.allowedTransportOptions != null &&
        this.allowedTransportOptions.length > 0
      );
    },
    isEducativeService() {
      return (
        store.state.peiTransportationInfo.peiAnalysisServiceCode ==
        peiProgramAreas.Educativo
      );
    },
    allowedOptions() {
      let filterOptions = this.options;

      if (!this.isEducativeService) {
        filterOptions = this.options.filter((a) => a.id != '139');
      }

      if (!this.canChangeTransport && this.hasAllowedOptions) {
        filterOptions = filterOptions.filter((option) =>
          this.allowedTransportOptions.some(
            (allowedOptId) => allowedOptId == option.id
          )
        );
      }

      return filterOptions;
    },
    isPS() {
      return store.getters.getIsPs;
    },
  },
};
</script>
